module.exports = __webpack_public_path__ + "img/date.71241560.png";